import React from 'react';

import { componentWithFG } from '@atlaskit/platform-feature-flags-react';
import type { HierarchyData } from '@atlassian/reporting-lines/hierarchy-chart';

import type { Collaborator, PersonProfileData, RecentWorkUrls } from '../types';

import { ContentSwitch } from './components/ContentSwitch';

export interface UserProfilePreviewProps {
	profileData?: PersonProfileData;
	hierarchyData?: HierarchyData;
	recentWorkData?: RecentWorkUrls;
	collaborators?: Collaborator[];
	isLoading?: boolean;
	testId?: string;
	cloudId: string;
	/** Organisation ID — required for interactive org chart navigation */
	orgId?: string;
	/** Site ID — required for interactive org chart navigation */
	siteId?: string;
}

const NoopComponent = () => null;

/**
 * Responsive user profile preview card. Adapts between full and compact layouts based on container width.
 *
 * @internal Not ready for consumption, Do not use in production.
 */
export const UserProfilePreview: React.FC<UserProfilePreviewProps & React.RefAttributes<unknown>> =
	componentWithFG('pt_user_profile_preview_enabled', NoopComponent, UserProfilePreviewComponent);

function UserProfilePreviewComponent({
	profileData,
	hierarchyData,
	recentWorkData,
	collaborators,
	isLoading = false,
	testId = 'user-profile-preview',
	cloudId,
	orgId,
	siteId,
}: UserProfilePreviewProps) {
	return (
		<ContentSwitch
			isLoading={isLoading}
			profileData={profileData}
			hierarchyData={hierarchyData}
			recentWorkData={recentWorkData}
			collaborators={collaborators}
			testId={testId}
			cloudId={cloudId}
			orgId={orgId}
			siteId={siteId}
		/>
	);
}
